import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { obj_type, int32_type, equals, record_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";

export class ContractEndUserDTO extends Record {
    constructor(FirstName, MiddleName, LastName, AlternateDisplayName, PostalAttention, PostalStreetAddress, PostalCode, PostalCity, PostalCountryCode, OrganizationNr) {
        super();
        this.FirstName = FirstName;
        this.MiddleName = MiddleName;
        this.LastName = LastName;
        this.AlternateDisplayName = AlternateDisplayName;
        this.PostalAttention = PostalAttention;
        this.PostalStreetAddress = PostalStreetAddress;
        this.PostalCode = PostalCode;
        this.PostalCity = PostalCity;
        this.PostalCountryCode = PostalCountryCode;
        this.OrganizationNr = OrganizationNr;
    }
}

export function ContractEndUserDTO$reflection() {
    return record_type("Containers.EndUserTable.Api.ContractEndUserDTO", [], ContractEndUserDTO, () => [["FirstName", option_type(string_type)], ["MiddleName", option_type(string_type)], ["LastName", option_type(string_type)], ["AlternateDisplayName", option_type(string_type)], ["PostalAttention", option_type(string_type)], ["PostalStreetAddress", option_type(string_type)], ["PostalCode", option_type(string_type)], ["PostalCity", option_type(string_type)], ["PostalCountryCode", option_type(string_type)], ["OrganizationNr", option_type(string_type)]]);
}

export function loadContractEndUser(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/ContractEndUser/%i/%i"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(option_type(ContractEndUserDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(option_type(ContractEndUserDTO$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(option_type(ContractEndUserDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function saveContractEndUser(clientNr, contractNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/ContractEndUser/%i/%i"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(int32_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(int32_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(ContractEndUserDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(2), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(int32_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export function deleteContractEndUser(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/ContractEndUser/%i/%i"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(int32_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(int32_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(void 0));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(4), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(int32_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

